import React, { useEffect } from 'react';
import FadeIn from './FadeIn';

const Contact = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = "https://server.fillout.com/embed/v1/";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <section
      id="contact"
      className="bg-brand-charcoal text-brand-vintage relative overflow-hidden"
      style={{ scrollMarginTop: '120px' }}
    >
      <div className="absolute top-0 right-0 w-1/2 h-full bg-brand-olive/5 skew-x-12 translate-x-1/4 pointer-events-none" />
      <div className="pt-28 md:pt-32 pb-24 md:pb-32 px-6 relative z-10">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24">
          {/* Left — Story Panel */}
          <FadeIn>
            <span className="text-brand-bronze uppercase tracking-[0.4em] text-[10px] font-bold mb-8 block">
              Begin Your Journey
            </span>
            <h2 className="font-serif text-4xl md:text-6xl lg:text-7xl mb-10 font-light leading-[1.1]">
              Start With <br />
              <span className="italic">Your Date</span>
            </h2>
            <p className="font-sans text-brand-vintage/60 mb-6 font-light text-base md:text-lg leading-relaxed max-w-md">
              Tell us a little about your celebration — your date, guest count, event type, and the style you're envisioning. If you'd like to schedule a private tour, just mention it and we'll make it happen.
            </p>
            <p className="font-sans text-brand-vintage/40 mb-16 font-light text-sm italic tracking-wide">
              No pressure. No hard sell. Just the right next step.
            </p>
            <div className="space-y-10">
              <div>
                <h4 className="text-[10px] uppercase tracking-[0.3em] text-brand-bronze mb-3 font-bold">
                  The Estate
                </h4>
                <p className="font-sans text-brand-vintage/70 font-light tracking-wide text-sm">
                  4467 Padua Ave, Claremont, CA 91711
                </p>
              </div>
              <div>
                <h4 className="text-[10px] uppercase tracking-[0.3em] text-brand-bronze mb-3 font-bold">
                  Connect
                </h4>
                <a
                  href="tel:909-624-8628"
                  className="font-sans text-brand-vintage/70 font-light tracking-wide text-sm block mb-2 hover:text-brand-vintage transition-colors"
                  aria-label="Call Padua Hills Theatre"
                >
                  909-624-8628
                </a>
                <a
                  href="mailto:paduahillstheatre@gmail.com"
                  className="font-sans text-brand-vintage/70 font-light tracking-wide text-sm underline decoration-brand-olive underline-offset-4 hover:text-brand-vintage transition-colors"
                  aria-label="Email Padua Hills Theatre"
                >
                  paduahillstheatre@gmail.com
                </a>
              </div>
            </div>
          </FadeIn>

          {/* Right — Fillout Form */}
          <FadeIn delay={0.2}>
            <div
              style={{ width: '100%', minHeight: '520px' }}
              data-fillout-id="1cr9DUsgj3us"
              data-fillout-embed-type="standard"
              data-fillout-inherit-parameters
              data-fillout-dynamic-resize
            />
            <p className="text-center mt-6 text-[9px] text-brand-vintage/30 uppercase tracking-[0.3em]">
              Padua Hills Theatre · Historic venue since 1930 · Claremont, CA
            </p>
          </FadeIn>
        </div>
      </div>
    </section>
  );
};

export default Contact;